module.exports = __webpack_public_path__ + "static/media/info.c78b9637.png";